import { motion } from "framer-motion";
import { Landmark, IdCard, Check } from "lucide-react";

const columns = [
  {
    icon: Landmark,
    accent: "brd",
    title: "Componenta bancară BRD",
    items: [
      "Cont curent în lei",
      "Card de debit pentru tineri",
      "Facilități bancare comunicate de BRD",
      "Experiență simplă pentru viața de zi cu zi",
    ],
  },
  {
    icon: IdCard,
    accent: "brand",
    title: "Componenta ISIC",
    items: [
      "Poți economisi peste 8.000 lei pe an",
      "Ai singura legitimație de elev sau student recunoscută la nivel global",
      "Primești acces la beneficii și reduceri exclusive în România",
      "Te bucuri de beneficii ISIC în peste 130 de țări",
    ],
  },
];

export const WhatIs = () => (
  <section id="despre" className="bg-zinc-50 border-y border-zinc-200 py-16 md:py-24" data-testid="what-is-section">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <div className="max-w-3xl">
        <h2 className="font-heading font-black text-3xl md:text-4xl tracking-tight text-zinc-900">
          Ce este BRD-ISIC?
        </h2>
        <p className="mt-5 text-base md:text-lg text-zinc-600 leading-relaxed">
          BRD-ISIC este cardul pentru elevi și studenți care îți oferă, într-un
          singur loc, funcționalitățile unui card de debit BRD și toate
          beneficiile legitimației internaționale ISIC. Îl folosești pentru
          plățile de zi cu zi și, în același timp, ai acces la mii de beneficii
          și reduceri ISIC în România și în întreaga lume.
        </p>
      </div>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        {columns.map((col, i) => (
          <motion.div
            key={col.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.12 }}
            data-testid={`what-is-column-${i}`}
            className="bg-white rounded-2xl border border-zinc-200 p-8 hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300"
          >
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${col.accent === "brd" ? "bg-brd/10" : "bg-brand/10"}`}>
              <col.icon className={`w-6 h-6 ${col.accent === "brd" ? "text-brd" : "text-brand"}`} />
            </div>
            <h3 className="font-heading font-bold text-xl text-zinc-900">{col.title}</h3>
            <ul className="mt-5 space-y-3">
              {col.items.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-zinc-600">
                  <Check className={`w-4 h-4 mt-0.5 shrink-0 ${col.accent === "brd" ? "text-brd" : "text-brand"}`} />
                  {item}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
